import React from "react";

import { useHistory } from "react-router-dom";

import ROUTES from "renter/config/routes";

import LoginPage from "shared/pages/LoginPage";
import { getQueryParams } from "shared/utils/routing";

const Login = () => {
  const history = useHistory();
  const urlParams = getQueryParams();

  const onSuccess = () => {
    window.location.href = `${window.location.origin}${urlParams?.r || ROUTES.home}`;
    return null;
  }

  return <LoginPage title="Leads Sign In" onSuccess={onSuccess} />;
};

export default Login;
